module.exports = __webpack_public_path__ + "static/media/payment1.ab498113.png";